module.exports = __webpack_public_path__ + "static/media/Template_21.9975d1b4.png";